module.exports = "\r\n\r\n.set {\r\n  display: flex;\r\n  margin-left: 40px;\r\n  margin-top: 10px;\r\n}\r\n\r\n\r\n"